import { type FC, useEffect } from 'react';
import { useSearchParams, Navigate } from 'react-router-dom';
import { ConfirmationStep } from '@/features/registration/components';
import { clearCart } from '@/lib/utils/cartPersistence';

/**
 * Standalone confirmation page for post-checkout redirects
 * Extracts orderId from URL query params and displays confirmation
 */
export const ConfirmationPage: FC = () => {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('orderId');

  // Clear persisted cart on successful checkout
  useEffect(() => {
    if (orderId) {
      clearCart();
    }
  }, [orderId]);

  // If no orderId, redirect to home
  if (!orderId) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-turquoise-800 via-turquoise-700 to-turquoise-800">
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <ConfirmationStep orderId={orderId} />
      </div>
    </div>
  );
};
